import { environment } from "../../../environments/environment";

const API_CONFIG = {
    BASE_URL: environment.serverUrl + "/api/v1/admin/",

    //Admin
    ADMIN_LOGIN: 'auth/login/',

    //Programs
    PROGRAMS: 'program/',

    //Activities
    ACTIVITIES: 'activity/',

    //Questions
    QUESTIONS: 'questions/',

    //Webinars
    WEBINARS: 'webinars/',

    //Users
    USERS: 'user/',

    //Feedbacks
    FEEDBACKS: 'feedbacks/',

    //Quotients
    QUOTIENT: 'quotients/',

    //Materials
    MATERIALS: 'materials/',

    //Materials
    CHAPTERS: 'chapter/',

    //Tasks
    TASKS: 'tasks/',
    DAILY_ACTIVITY: 'daily-activity/',


    //Customer Enquiry
    ENQUIRY_LIST: 'customer-enquiry/list',

    //Master
    GET_MASTER: 'master/fetch/',

    //Age group
    GET_AGE_GROUP: 'age-group/',

    //Notification
    NOTIFICATION: 'notifications/',

    //Affiliates
    AFFILIATES: 'affiliate/',

    //Communities
    COMMUNITIES: 'communities/',

    //Counsellors / Admin Users
    COUNSELLORS: 'counsellors/',

    SETTINGS: 'settings/',

    UPDATE_PROFILE: 'auth/profile/',

    //Subscriptions
    SUBSCRIPTIONS: 'subscriptions/',
}

export { API_CONFIG };
